import * as Yup from 'yup';

const APISecretSchema = Yup.object().shape({
  name: Yup.string().required('Required'),
  uid: Yup.string().required('Required'),
  secret: Yup.string().required('Required'),
})

export default APISecretSchema
